import { defineStore } from 'pinia'
import { ensureElement, get, toJson } from '@/common/util'
import _ from 'lodash-es'
import { jwtDecode } from 'jwt-decode'
import dayjs from 'dayjs'
import { useToast,POSITION } from 'vue-toastification'
import { useI18n } from 'vue-i18n'
import UploadSv from '@/components/UploadSv.vue'
import { computed ,ref} from 'vue'
import config from '@/common/config'

export const useMemberStore = defineStore('member', () => {
  const mid = ref(null)
  const mname = ref(null)
  const authorities=ref(null)
  const iss=ref(null)
  const exp=ref(null)
  const iat = ref(null)
  const jwt = ref(null)
  function reset(){
    mid.value=null
    mname.value=null
    authorities.value=null
    iss.value=null
    exp.value=null
    iat.value=null
    jwt.value=null
  }
  function logout(){
    reset()
  }
  function isLoggedIn(){return !_.isEmpty(jwt.value)&&!expired();}
  function isAdm(){return (authorities.value&&authorities.value.toLowerCase().includes('admin'));}
  function init(ojwt,omname){
    const jwtinfo=jwtDecode(ojwt)
    mid.value=jwtinfo.sub
    if(omname)mname.value=omname
    iss.value=jwtinfo.iss
    exp.value=jwtinfo.exp*1000
    //exp.value=Date.now()+5000
    iat.value=jwtinfo.iat
    authorities.value=jwtinfo.authorities
    jwt.value=ojwt
    bearertoken.value='Bearer '+jwt.value
  }
  function expNowDiff(unit='second'){
    const rslt=exp.value?dayjs(exp.value).diff(dayjs(),unit):-1
    if(rslt<0)reset()
    return rslt
  }
  function expired(){
    return expNowDiff()<0
  }
  const bearertoken=computed(()=>'Bearer '+jwt.value)
  return {mid,mname,authorities,jwt,iss,exp,iat,bearertoken,reset,logout,isAdm,isLoggedIn,init,expNowDiff,expired}
},{persist:true})
export const useSiteConfigStore=defineStore('sitestore',()=>{
  const locale=ref('kr')
  return{locale}
},{persist:true})
export const useEntityStructureStore=defineStore('entitystructure',()=>{
  const entities=ref({})
  function ensureAll(callback=()=>{}){
    if(_.isEmpty(entities.value)){
      get('rest/authed/member/structures',resp=>{
        _.entries(resp.data).forEach(ent=>_.entries(ent[1]).forEach(sub=>{
          const arr=sub[1].split('|')
          resp.data[ent[0]][sub[0]]={tkey:arr[0],type:arr[1],cn:sub[0]}
        }))
        entities.value=resp.data
        callback(toJson(entities.value))
      },err=>{
        console.log(err)
      })
    }else callback(toJson(entities.value))
  }
  function ensureItem(name,callback){
    ensureAll(all=>callback(all[name]))
  }
  function loaded(){
    return _.isEmpty(entities.value)
  }
  return {ensureAll,ensureItem,loaded}
})
export const useMetaStore = defineStore('meta', () => {
  const upproctoasts=ref({})
  const onServerRequest = ref(false)
  const appisloading = ref(false)
  const apponoverlay = ref(false)
  const apppersist = ref(false)
  const appoverlayonclose = ref(() => {})
  function overlay({ isloading, onoverlay, persist }) {
    isdialog.value = false
    apponoverlay.value = onoverlay
    appisloading.value = isloading
    if (isloading === true) apponoverlay.value = true
    apppersist.value = persist
  }
  function pop({ callback, persist, ison, onclose }) {
    overlay({ isloading: false, onoverlay: ison, persist: persist })
    if (callback) ensureElement('#popbody', callback)
    if (!ison&&appoverlayonclose.value) appoverlayonclose.value()
    appoverlayonclose.value = () => {}
    if (onclose) appoverlayonclose.value = onclose
  }
  function blockLoading(flag) {
    if (flag === true || flag == null)
      overlay({ isloading: true, onoverlay: true, persist: true })
    else overlay({ isloading: false, onoverlay: false, persist: false })
  }
  const toastmaker = useToast()
  const toastposition=POSITION
  const i18n = useI18n()
  const toast = (msg, issucc = true) =>
    setTimeout(() => {
      if (issucc) toastmaker.success(msg)
      else toastmaker.error(msg)
    }, 100)
  const t = (tk) => i18n.t(tk)
  const toastKey = (tk, issucc = true) => toast(t(tk), issucc)
  const toastRslt = (res, issave = true, tkey) => {
    let textkey = tkey
    if (!tkey) {
      if (res.isSuccess) {
        if (issave) textkey = 'thesaveiscomplete'
        else textkey = 'thedeletioniscomplete'
      } else {
        if (issave)
          textkey = 'anerroroccurredwhilesavingpleasetryagaininamoment'
        else textkey = 'deletefailed'
      }
    }
    if (res.msg) textkey = res.msg
    toastKey(textkey, res.isSuccess)
  }
  const isdialog = ref(false)
  const isdialogtk = ref(true)
  const dialogttl = ref('')
  const dialogcont = ref('')
  const dialogshowcancel = ref(true)
  const dialogoncancel = ref(() => {})
  const dialogonok = ref(() => {})
  function dialog({
    shown = true,
    ttl,
    cont,
    showcancel = true,
    istk = true,
    persist,
    oncancel = () => {},
    onok = () => {},
    onclose = () => {},
  }) {
    isdialogtk.value = false
    if (shown === false) {
      appoverlayonclose.value()
      appoverlayonclose.value = () => {}
      return overlay({ isloading: false, onoverlay: false, persist: false })
    }
    overlay({ isloading: false, onoverlay: true, persist: persist })
    isdialog.value = true
    isdialogtk.value = istk
    dialogttl.value = ttl
    dialogcont.value = cont
    dialogshowcancel.value = showcancel
    apppersist.value = persist
    dialogoncancel.value = oncancel
    dialogonok.value = onok
    appoverlayonclose.value = () => {}
    appoverlayonclose.value = onclose
  }
  function toastAndUploadSv({svid,files,detectptdist,linkdist,upfiledt,upfilenmeaext,upfilepostype,upproctype,svnm,upfilesection,serverpath,callback}){
    toastmaker({component:UploadSv,props:{svid,files,detectptdist,linkdist,upfiledt,upfilenmeaext,upfilepostype,upproctype,svnm,upfilesection,serverpath,callback}},{
      position: "top-right",
      timeout: false,
      closeOnClick: false,
      pauseOnFocusLoss: false,
      pauseOnHover: false,
      draggable: false,
      draggablePercent: 0,
      showCloseButtonOnHover: false,
      hideProgressBar: true,
      closeButton: false,
      icon:false
    })
  }
  function toastAndChkUpSvProc(bpid,svnm,svid,callback){
    toastmaker({component:UploadSv,props:{bpid,svnm,svid,callback}},{
      position: "top-right",
      timeout: false,
      closeOnClick: false,
      pauseOnFocusLoss: false,
      pauseOnHover: false,
      draggable: false,
      draggablePercent: 0,
      showCloseButtonOnHover: false,
      hideProgressBar: true,
      closeButton: false,
      icon:false
    })
  }
  const faviconurl=ref(config.backend+'favicon')
  const logourl=ref(config.backend+'logo')
  const logo_fronturl=ref(config.backend+'logo_front')
  const dispmode=ref('')
  const searchParams=ref({layer:null,streetview:null,objectdetect:null})
  return {
    onServerRequest,
    apponoverlay,
    appisloading,
    apppersist,
    toast,
    toastKey,
    t,
    toastRslt,
    overlay,
    pop,
    blockLoading,
    isdialog,
    isdialogtk,
    dialogttl,
    dialogcont,
    dialogshowcancel,
    dialogoncancel,
    dialogonok,
    appoverlayonclose,
    dialog,
    toastmaker,
    toastposition,
    toastAndUploadSv,
    toastAndChkUpSvProc,
    faviconurl,
    logourl,
    logo_fronturl,
    dispmode,
    upproctoasts,
    searchParams
  }
})

